class SeasonProduct {
	constructor({
		id = '',
		seasonId = '',
		productId = '',
		seasonUsd = 0,
		seasonKrw = 0,
		seasonDiscountUsd = 0,
		materialCostUsd = null as number | null,
		materialCostKrw = null as number | null,
		seasonQuantity = 0,
		seasonActiveYn = 0,
		preorderYn = 0,
		currentPhase = '',
		phaseUsd = 0,
		phaseKrw = 0,
		preorderClosedYn = 0,
		phaseGapYn = 0,
		nextPhaseAt = '',
		phases = [],
		partOrderedAt = '',
		productionStartAt = '',
		deliveryStartAt = '',
		deliveryCompletedAt = '',
		updatedBy = '',
		updatedAt = '',
		createdBy = '',
		createdAt = '',
		productName = '',
		productCode = '',
		productIndex = 0,
		seasonStartDate = '',
		seasonEndDate = '',
		standardUsd = 0,
		soldUsd = 0,
		discountedUsd = 0,
		soldQuantity = 0,
		productUseYn = 0,
		alwaysAvailableYn = 0,
		notStartYn = 0,
		expiredYn = 0,
		soldOutYn = 0,
		status = 'active',
	} = {}) {
		this.id = id === null ? '' : id
		this.seasonId = seasonId === null ? '' : seasonId
		this.productId = productId === null ? '' : productId
		this.seasonUsd = seasonUsd === null ? 0 : seasonUsd
		this.seasonKrw = seasonKrw === null ? 0 : seasonKrw
		this.seasonDiscountUsd = seasonDiscountUsd === null ? 0 : seasonDiscountUsd
		this.seasonQuantity = seasonQuantity === null ? 0 : seasonQuantity
		this.materialCostUsd =
			materialCostUsd === null || materialCostUsd === undefined
				? null
				: Number(materialCostUsd)
		this.materialCostKrw =
			materialCostKrw === null || materialCostKrw === undefined
				? null
				: Number(materialCostKrw)
		this.seasonActiveYn = seasonActiveYn === null ? 0 : seasonActiveYn
		this.preorderYn = preorderYn === null ? 0 : preorderYn
		this.currentPhase = currentPhase === null ? '' : currentPhase
		this.phaseUsd = phaseUsd === null ? 0 : phaseUsd
		this.phaseKrw = phaseKrw === null ? 0 : phaseKrw
		this.preorderClosedYn = preorderClosedYn === null ? 0 : preorderClosedYn
		this.phaseGapYn = phaseGapYn === null ? 0 : phaseGapYn
		this.nextPhaseAt = nextPhaseAt === null ? '' : nextPhaseAt
		this.phases = phases === null ? [] : phases
		this.partOrderedAt = partOrderedAt === null ? '' : partOrderedAt
		this.productionStartAt = productionStartAt === null ? '' : productionStartAt
		this.deliveryStartAt = deliveryStartAt === null ? '' : deliveryStartAt
		this.deliveryCompletedAt = deliveryCompletedAt === null ? '' : deliveryCompletedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.createdBy = createdBy === null ? '' : createdBy
		this.createdAt = createdAt === null ? '' : createdAt
		this.productName = productName === null ? '' : productName
		this.productCode = productCode === null ? '' : productCode
		this.productIndex = productIndex === null ? 0 : productIndex
		this.seasonStartDate = seasonStartDate === null ? '' : seasonStartDate
		this.seasonEndDate = seasonEndDate === null ? '' : seasonEndDate
		this.standardUsd = standardUsd === null ? 0 : standardUsd
		this.soldUsd = soldUsd === null ? 0 : soldUsd
		this.discountedUsd = discountedUsd === null ? 0 : discountedUsd
		this.soldQuantity = soldQuantity === null ? 0 : soldQuantity
		this.productUseYn = productUseYn === null ? 0 : productUseYn
		this.alwaysAvailableYn = alwaysAvailableYn === null ? 0 : alwaysAvailableYn
		this.notStartYn = notStartYn === null ? 0 : notStartYn
		this.expiredYn = expiredYn === null ? 0 : expiredYn
		this.soldOutYn = soldOutYn === null ? 0 : soldOutYn
		this.status = status === null ? 'active' : status
	}
	id: string
	seasonId: string
	productId: string
	seasonUsd: number
	seasonKrw: number
	/** 재료원가 — 정산 원가의 첫 출처(판매일의 시즌). DISPATCH_PLAN §6.3 */
	materialCostUsd: number | null
	materialCostKrw: number | null
	seasonDiscountUsd: number
	seasonQuantity: number
	seasonActiveYn: number
	preorderYn: number
	currentPhase: string
	phaseUsd: number
	phaseKrw: number
	preorderClosedYn: number
	phaseGapYn: number
	nextPhaseAt: string
	phases: any[]
	partOrderedAt: string
	productionStartAt: string
	deliveryStartAt: string
	deliveryCompletedAt: string
	updatedBy: string
	updatedAt: string
	createdBy: string
	createdAt: string
	productName: string
	productCode: string
	productIndex: number
	seasonStartDate: string
	seasonEndDate: string
	standardUsd: number
	soldUsd: number
	discountedUsd: number
	soldQuantity: number
	productUseYn: number
	alwaysAvailableYn: number
	notStartYn: number
	expiredYn: number
	soldOutYn: number
	status: string // not_start | expired | inactive | sold_out | active
}

export { SeasonProduct }
